import * as React from "react"
import Layout from "../../components/layout/layout";

import beardg from "./../../images/products/safe/beardguard.jpg"
import lamiantiskid from "./../../images/products/safe/lamiantiskid.jpg"
import lamiapron from "./../../images/products/safe/lamiapron.jpg"
import peapron from "./../../images/products/safe/peapron.jpg"
import shoecoveranti from "./../../images/products/safe/shoecoveranti.jpg"
import shoecoverreg from "./../../images/products/safe/shoecoverreg.jpg"
import shoepe from "./../../images/products/safe/shoepe.jpg"
import bootleg from "./../../images/products/safe/bootleg.jpg"
import sleevepe from "./../../images/products/safe/sleevepe.jpg"
import sleevelami from "./../../images/products/safe/sleevelami.jpg"

const SafeTechPage = () => {
    return (
        <Layout pageName={"Safe Tech"}>
            <div className="container justify-content-center align-items-center">
                <p
                    data-sal="fade"
                    data-sal-delay="100"
                    data-sal-easing="easeInExpo"
                    className="pb-10 lead fs-23 my-3"
                >
                    <i className="text-orange bi bi-arrow-right-short"/>
                    For use in industries like Bio-tech, food processing, chemical, automotive etc, restaurants, paint
                    shops,
                    manufacturing, janitorial and housekeeping.
                </p>
                <div className="pb-15 grid grid-view text-center ">
                    <div className="row gx-md-8 gy-10 gy-md-13">
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={beardg} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Beard Guard
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                15 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                18"
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP Spun Bond
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={shoecoverreg} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Shoe Covers - Regular
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                25 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Blue, White
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                6" H x 16" L
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP Spun Bond
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={shoecoveranti} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Shoe Covers - Premium - Anti slip Printed
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                40, 45 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Medical Blue
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                17.5 L x 7.5 W
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP Spun Bond
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={lamiantiskid} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Shoe Covers - Laminated with anti skid film
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                40 + 20 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Blue
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                8" H x 18" L
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP Spun Bond + PE Laminate
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={shoepe} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">Shoe Covers - PE </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                20 Micron
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Blue
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                16" H x 6.5" L
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PE
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={peapron} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        PE Aprons
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                20 Micron
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Blue , White, Green
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                47" x 31.5"
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PE
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={lamiapron} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Laminated Non woven Aprons
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                13 + 10 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard Size
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP Spun Bond
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={bootleg} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Boot Leggings
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                70 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Size: Standard white laminate (with printing and velcro)
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Various Models
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={sleevepe} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Sleeves Covers - PE
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                20 micron
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White Blue
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                8" X 18"
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PE
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top border-bottom">
                                    <img className="img-fluid" src={sleevelami} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Sleeves Covers - Laminated Nonwovens
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                23 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                8" x 18"
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP Spun Bond
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default SafeTechPage